import { Skeleton } from "@mui/material";

import { ReviewVisitTableCell } from "../../../../components/ReviewVisitTable";

export default function TimeReportTableRowSkeleton() {
    return (
        <>
            <ReviewVisitTableCell>
                <Skeleton variant="text" width={120} height={20} />
            </ReviewVisitTableCell>
            <ReviewVisitTableCell>
                <Skeleton variant="text" width={80} height={20} />
                <Skeleton variant="text" width={100} height={18} />
            </ReviewVisitTableCell>
            <ReviewVisitTableCell>
                <Skeleton variant="text" width={80} height={20} />
                <Skeleton variant="text" width={100} height={18} />
            </ReviewVisitTableCell>
            <ReviewVisitTableCell>
                <Skeleton variant="text" width={60} height={20} />
            </ReviewVisitTableCell>
        </>
    );
}
